import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, input } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faTrash, faUsers, faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Editor, Toolbar } from 'ngx-editor';
import { ReportService } from 'src/app/services/report.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-select-wo-officer',
  templateUrl: './select-wo-officer.component.html',
  styleUrls: ['./select-wo-officer.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})


export class SelectWOOfficerComponent implements OnChanges, OnInit {

  faUsers = faUsers;
  faTrash = faTrash;
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;
  filtered_roles: any[] = [];

  toolbar: Toolbar = APP_CONSTANTS.EDITOR_TOOLBAR;

  editors: Editor[] = [];

  report = input.required<any>();
  @Input() loSelected!: Subject<boolean>;
  forests: any[] = []
  regions: any[] = []
  lastCheckedEmail: any = "";
  roles: any;


  displayedColumns: string[] = ["name", "position"];
  users = new MatTableDataSource<any>();
  selectUserId: number | null = null;

  fireForm = this.formBuilder.group({
    radio: [""],
  });

  doesUserExist: boolean = false;
  existingUser: any;

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly userService: UserService,
    public readonly dialogService: DialogService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    this.roles = this.userService.getRoleList();
    this.filtered_roles = this.roles?.filter((r: any) => r.type == "WOLO");
  }

  ngOnInit(): void {
    this.loadUsers();
    let newForest = {} as any;
    newForest.form = this.formBuilder.group({
      name_search: [""],
      // new_or_existing: [forest.line_officer ? "existing" : ""],
      new_or_existing: [""],
      user_select: [""],
      first_name: [""],
      last_name: [""],
      email: [""],
      phone_num: [""],
      lo_position: [""]
    })
    newForest.selectUserForm = this.formBuilder.group({
      // user: [forest.line_officer ?? ""],
      user: [null],
    })
    newForest.userExists = false;
    newForest.contact = null;
    newForest.users = new MatTableDataSource<any>();
    this.forests = [
      newForest
    ]
  }

  ngOnChanges(): void {
  }

  loadUsers() {
    this.userService.getUserList("LO", ["baer_roles.baer_role"]).subscribe(data => {
      let users = data.users
      users.forEach((user: any) => {
        user.baer_roles = user.baer_roles.filter((role: any) => {
          return role.baer_role.type == "WOLO"
        })
        user.tooltip = user.baer_roles.map((role: any) => role.baer_role.text).join("\n")
      })
      users = users.filter((user: any) => user.baer_roles.length > 0)
      this.forests.forEach((forest: any) => {
        let LOs = users
        forest.users.data = LOs
        let signature = this.findExistingSignature()
        if (this.selectUserId) {
          let user = LOs.find((user: any) => user.user_id == this.selectUserId)
          if (user) {
            forest.selectUserForm.patchValue({
              user: user,
            })
            forest.form.patchValue({
              new_or_existing: 'existing',
            })
          }
          this.update()
        } else if (signature) {
          let user_id = signature.user_id
          let user = LOs.find((user: any) => user.user_id == user_id)
          forest.selectUserForm.patchValue({
            user: user,
          })
          forest.form.patchValue({
            new_or_existing: 'existing',
          })
          this.loSelected.next(true);
        }
        if (forest.selectUserForm.value.user) {
          forest.selectUserForm.patchValue({
            user: LOs.find((user: any) => user.user_id == forest.selectUserForm.value.user.user_id)
          })
        }
      })
      this.update()
      this.users.data = users
      this.dialogService.closeSpinner()
    });
  }

  radioChange(event: any, forest: any) {
    let signature = this.findExistingSignature()
    if (signature) {
      this.editSignature(event.value.user_id, signature.report_signature_id)
    } else {
      this.createSignature(event.value.user_id)
    }
    this.update(forest);
    this.loSelected.next(true);
  }

  checkIfUserExists(forest: any): void {
    if (forest.form.controls.email.errors?.pattern) {
      forest.form.controls.email.setErrors({ "pattern": forest.form.controls.email.errors.pattern })
      return
    }
    let email = forest.form.value.email
    if (this.lastCheckedEmail == email) return // Prevent double event firing
    this.lastCheckedEmail = email
    if (email == "") {
      forest.form.controls.email.setErrors(null)
      return
    }
    let foundUser = forest.users.data.find((user: any) => user.email == email)
    if (foundUser) {
      forest.selectUserForm.patchValue({
        user: foundUser,
      })
      forest.form.patchValue({
        new_or_existing: 'existing',
      })
      let signature = this.findExistingSignature()
      if (signature) {
        this.editSignature(foundUser.user_id, signature.report_signature_id)
      } else {
        this.createSignature(foundUser.user_id)
      }
      this.update(forest);
      this.toast.openSuccessSnackBar(`Existing Line Officer Found`, "The line officer with that email address has been selected.");
      return
    }

    this.dialogService.openSpinner();
    this.userService.getUsersByEmail(email).subscribe({
      next: (response) => {
        this.dialogService.closeSpinner();
        if (response.totalResults > 0) {
          this.doesUserExist = true;
          this.existingUser = response.users?.[0];
          forest.form.controls.first_name.patchValue(this.existingUser.first_name);
          forest.form.controls.last_name.patchValue(this.existingUser.last_name);
          forest.form.controls.phone_num.patchValue(this.existingUser.phone_num);
        } else {
          this.doesUserExist = false;
          this.existingUser = undefined;
        }

      },
      error: (response) => {
        forest.userExists = false;
        this.dialogService.closeSpinner();
      },
      complete: () => {
        this.update()
      }
    })
  }

  update(doneForest?: any) {
    let touched = false
    let complete = true

    this.forests.forEach((forest: any) => {
      if (doneForest?.forest_id == forest.forest_id) {
        touched = true
        return
      }
      if (forest.selectUserForm.value.user) {
        touched = true
      } else {
        complete = false
      }
    })

    if (touched) {
      this.report().page_9_status_id = 1;
    }
    if (complete) {
      this.report().page_9_status_id = 2;
    }
  }

  upsertLineOfficer(forest: any) {
    let phone_num = forest.form.value.phone_num
    if (forest.form.value.phone_num == "") {
      phone_num = undefined
    }
    this.dialogService.openSpinner()
    if (!this.doesUserExist) {
      this.userService.createNewUser({
        first_name: forest.form.value.first_name!,
        last_name: forest.form.value.last_name!,
        region: forest.region,
        forest_name: forest.forest_name,
        agency_id: 0,
        phone_num: phone_num,
        email: forest.form.getRawValue().email!,
        user_baer_roles: [{ baer_role_id: forest.form.value.lo_position.value }],
        procedure: "NEW_TO_LINE_OFFICERS"
      }).subscribe((response: any) => {
        if (response.user_id) {
          this.selectUserId = response.user_id
          this.loadUsers()
        }
      })
    } else {
      this.userService.editUserDetails({
        user_id: this.existingUser.user_id,
        first_name: forest.form.value.first_name!,
        last_name: forest.form.value.last_name!,
        region: forest.region,
        forest_name: forest.forest_name,
        agency_id: 0,
        phone_num: phone_num,
        user_baer_roles: [{ baer_role_id: forest.form.value.lo_position.value, location_id: 2 }],
        procedure: "REASSIGN"
      }).subscribe(() => {
        this.selectUserId = this.existingUser.user_id
        this.radioChange({ value: { user_id: this.existingUser.user_id } }, forest)
        this.loadUsers()
      });
    }
  }

  findExistingSignature(): any {
    for (let sign of this.report().signatures) {
      if (sign.signature == "Pending Signature" && sign.region == "WO" && sign.signature_type_id == 2) {
        return sign
      }
    }
    return null
  }

  createSignature(user_id: number) {
    this.reportService.createReportSignature({
      report_id: this.report().report_id,
      signature_type_id: 2,
      region: "WO",
      signature: "Pending Signature",
      user_id: user_id,
    }).subscribe({
      next: (response: any) => {
        this.report().signatures.push({
          report_id: this.report().report_id,
          signature_type_id: 2,
          region: "WO",
          signature: "Pending Signature",
          user_id: user_id,
          report_signature_id: response.report_signature_id
        })
      },
      error: (response: any) => {

        this.toast.openErrorSnackBar(`There was an error updating the report.`, "Please try again.");

      },
    })
  }

  editSignature(user_id: number, report_signature_id: number) {
    this.reportService.editReportSignature({
      user_id: user_id,
    }, report_signature_id.toString()).subscribe({
      next: (response: any) => {
      },
      error: (response: any) => {

        this.toast.openErrorSnackBar(`There was an error updating the report.`, "Please try again.");

      },
    })
  }
}
